import React, { useEffect } from 'react'
import { useGlobal } from 'reactn';
import { User } from 'oidc-client';
import { RouteComponentProps } from 'react-router-dom';
import Auth, { AuthDataType, saveIdentityInStorage} from './types/auth';
import { IGlobalState } from './states/GlobalState';
import { getIdentity } from './services/identityService';
import { Principal } from './models/principal';
import { useLogger } from './logger';
import { DateSchema } from 'yup';
import moment from 'moment';
import { Roles } from '../src/models';
import { SerializationHelper } from './serializable/helper';
import { AgencyState } from './models/objects';

type OidcCallbackProps = RouteComponentProps & {
    onAuthDataLoaded?: (ad: AuthDataType) => void,
}

export const OidcCallback = (props: OidcCallbackProps) => {
    const [auth,setAuth] = useGlobal<IGlobalState, 'auth'>('auth')
    console.log('OidcCallback', {auth});
    const[,setIdentity] = useGlobal<IGlobalState, 'identity'>('identity');
    const[ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const[, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const userManager = Auth.getDefaultUserManager();
    const logger = useLogger({key: 'identity'});
    const abortController = new AbortController();
    const signal = abortController.signal;

    const successCallback = async (user: User) => {
        console.log('Eseguo callback corretta');
        console.log({user})
        // Cerchiamo authData
        if(user) {
            // console.log('Sono in User e aggiorno lo user del Oidc client nello store');
            // dal ritorno della CallBack del Oidc devo salvare i dati di autenticazione
            await userManager.storeUser(user);
            // throw new Error('Boundary non catcha l\'errore in Oidc callback ');
            // Aggiorno lo stato global della applicazione
            // console.log('Aggiorno lo user del Oidc client nello stato global di react N');
            // setGlobal({...global, user: user});

            Auth.getAuthData(user.access_token, signal).then(ad => {
                const authData = ad || null;
                setAuth({...auth, user, authData })
                Auth.saveAuthData(authData, user)
                if(props.onAuthDataLoaded && authData) {
                    console.log('Eseguo onAuthDataLoaded di LoggedInRouting');
                    props.onAuthDataLoaded(authData)
                }                    
                // let username = authData!.user;
                getIdentity(ip, authData!, user)
                    .then((res: Principal) => {
                        let identityAuth = SerializationHelper.toInstance(new Principal(), JSON.stringify(res));
                        setIdentity(identityAuth);
                        setGlobalWait(false);
                        // HACK vmorell 20210417 controlli sulle date usando la moment
                        if (res.Disabled && moment(new Date()).format('YYYYMMDD') >= moment(res.Disabled!).format('YYYYMMDD')) {
                            // console.log('Utente is disabled: ');
                            auth.user = null;
                            setAuth(auth);
                            userManager.clearStaleState();
                            userManager.removeUser();
                            setIdentity(null);
                            logger.error('Utente disabilitato');
                            setGlobalWait(false);
                        }  else if (identityAuth.Role !== Roles.SUPERADMIN && !identityAuth.PrincipalAuth[0]) {
                            auth.user = null;
                            setAuth(auth);
                            userManager.clearStaleState();
                            userManager.removeUser();
                            setIdentity(null);
                            logger.error('Agenzia utente mancante. Autenticazione fallita');
                            setGlobalWait(false);                        

                        }  else if (identityAuth.Role !== Roles.SUPERADMIN && identityAuth.PrincipalAuth[0].Agency?.State === AgencyState.Suspended) {
                            auth.user = null;
                            setAuth(auth);
                            userManager.clearStaleState();
                            userManager.removeUser();
                            setIdentity(null);
                            logger.error('Agenzia sospesa. Autenticazione fallita');
                            setGlobalWait(false);                        

                        }  else if (identityAuth.Role !== Roles.SUPERADMIN && 
                                (identityAuth.PrincipalAuth[0].Agency?.Disabled && 
                                    moment(new Date()).format('YYYYMMDD') >= moment(identityAuth.PrincipalAuth[0].Agency.Disabled!).format('YYYYMMDD'))
                                ) 
                            {
                            console.log('Data disabled from moment: ' + moment(identityAuth.PrincipalAuth[0].Agency.Disabled!).format('YYYYMMDD'));
                            console.log('Data today now: ' + moment(new Date()).format('YYYYMMDD'));
                            // Verifica agenzia dell'utente disabilitata
                            auth.user = null;
                            setAuth(auth);
                            userManager.clearStaleState();
                            userManager.removeUser();
                            setIdentity(null);
                            logger.error('Agenzia utente disabilitata');
                            setGlobalWait(false);                        
                        } else {
                            props.history.push('/');
                        }
                    })
                    .catch(ex => {
                        console.log({ex});
                        auth.user = null;
                        setAuth(auth);
                        userManager.clearStaleState();
                        userManager.removeUser();
                        logger.error(ex.message);
                        setGlobalWait(false);
                        setIdentity(null);
                        // abortController.abort(); 
                    });                    
            })
            .catch(error => {
                setGlobalWait(false);
                console.error('Auth.getAuthData',{error});
                // abortController.abort(); 
            })
        }
    };
    
    const errorCallback = (error: any) => { 
        console.log('Errore in oidc callback is: ' + error);
        setGlobalWait(false);
        // abortController.abort(); 
        props.history.push('/login');
    };
    
    useEffect(() => {                
        auth.userManager.signinRedirectCallback()
            .then((user: User) => {
                setGlobalWait(true);
                successCallback(user);
            })
            .catch((error) => {
                // setGlobal({...global, globalWait: false});
                errorCallback(error)
                // abortController.abort(); 
            });

        // Funzione di cleanup di Useeffect    
        return function cleanup() {
            console.log('cleanup');
            abortController.abort(); 
        }
    })

    return (
        <React.Fragment></React.Fragment>
    )
}